import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  getWebPageLink,
  WebPageLink,
  WebPageType,
} from '../constants/webPageType';

const useRedirectHome = (
  condition: boolean,
  webPageType: WebPageType = WebPageType.JOYAJOY,
) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (condition) {
      navigate(getWebPageLink(webPageType, WebPageLink.Home), {
        replace: true,
      });
    }
  }, [condition, navigate, webPageType]);
};

export default useRedirectHome;
